import React from 'react'
import { AppFormBlockTitle } from '../AppFormItem/AppFormBlockTitle'
import { AppFormBlock as AppFormBlockProps, AppFormItem as AppFormItemProps } from 'api'

interface Props extends AppFormBlockProps {
	children: React.ReactNode
}

interface ItemProps extends AppFormItemProps {
	lastItem?: boolean
	child: any
}

export const AppFormBlock = (props: Props) => {
	const renderItem = (itemProps: ItemProps) => {
		let tds: any = []
		let colSpan = (itemProps.colSpan - 1) * 3 + 1
		if (itemProps.labelHidden) colSpan++

		if (!itemProps.labelHidden) {
			tds.push(
				<td key={`title`}>
					<label className="app-from-title" data-req={itemProps.req}>
						{itemProps.label || ''}
					</label>
				</td>
			)
		}

		tds.push(
			<td key={`field`} colSpan={colSpan} style={{ padding: '5px 0' }}>
				{itemProps.child}
			</td>
		)

		if (!itemProps.lastItem) {
			tds.push(<td key={`split`}></td>)
		}
		return tds
	}

	const getRowList = () => {
		let itemList: any[] = React.Children.toArray(props.children)
		let rowList: any[] = []
		let colNumber = props.colNumber || 1
		let rowsIndex = -1 // 行号
		let rowItemCounts = 0 // 行item数量

		for (let i = 0; i < itemList.length; i++) {
			let appFormItem: ItemProps = {
				...itemList[i].props,
				colSpan: itemList[i].props.colSpan || 1,
				child: itemList[i],
			}

			let colSpan = appFormItem.colSpan
			if (colSpan > colNumber) colSpan = colNumber

			if (rowItemCounts === 0) {
				rowsIndex++
				rowList.push([] as any)
			}

			// 如果剩余的item数不够，则强行将下一个item的colSpan改成和剩余数一样
			if (rowItemCounts + colSpan === colNumber) {
				appFormItem.lastItem = true
				rowItemCounts = 0
			} else {
				appFormItem.lastItem = false
				rowItemCounts = rowItemCounts + colSpan
			}

			rowList[rowsIndex].push(renderItem(appFormItem))
		}

		return rowList
	}

	const renderTitle = () => {
		let title = props.title || ''
		return title === '' ? <React.Fragment /> : <AppFormBlockTitle title={title} />
	}

	const renderLayout = () => {
		let colNumber = props.colNumber || 1
		let labelWidth = props.labelWidth || 70
		let cols = []
		for (let i = 0; i < colNumber; i++) {
			if (i > 0) cols.push(<col key={`${i}_space`} width="20px" />)
			cols.push(<col key={`${i}_lable`} width={`${labelWidth}px`} />)
			cols.push(<col key={`${i}_field`} />)
		}
		return <colgroup>{cols}</colgroup>
	}

	const renderFormBlock = () => {
		let rowList = getRowList()
		return (
			<div className="app-form-block">
				{renderTitle()}
				<table cellPadding="0" cellSpacing="0" style={{ width: '100%' }}>
					{renderLayout()}
					<tbody>
						{rowList.map((row: any, index) => {
							return <tr key={index}>{row}</tr>
						})}
					</tbody>
				</table>
			</div>
		)
	}

	return props.isHidden ? <React.Fragment /> : renderFormBlock()
}



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormBlock.tsx